
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
// import { getVote } from './api';

@Component
export default class ViewHolder extends Vue {
  @Watch('$route', { immediate: true })
  onRouteChange() {
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    const title = '川渝重点旅游景区住宿场所卫生“你点名  我监督”';
    const subtitle = '重庆市疾控局、四川省疾控局、上游新闻邀你“点名”';
    this.$appShareInfo({
      title,
      url: location.href,
      subtitle,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    if (isWeiXin())
      this.$wxShareInfo({
        title,
        subtitle,
        image: cover,
      });
  }

  created() {
    // const vote = getVote();
    // if (vote && this.$route.path.endsWith('/pick')) this.$router.replace({ path: '/20260901JQDM/lock' });
  }
}
